import API from 'utils/api';
import { message } from 'antd';
import getFormattedValues, { DATE_FORMAT } from 'utils/formatValues';
import { toMoment } from 'utils/normalizers';
import { onError } from 'utils/handlers';
import { postHistorialDeCita } from './historialDeCita';

export const baseURI = 'recaudacion/citas/';

const formatter = (c) => ({
  ...c,
  fecha_alta: toMoment(c.fecha_alta),
  fecha_cita: toMoment(c.fecha_cita),
  horario_inicio: toMoment(`${c.fecha_cita} ${c.horario_inicio}`, [`${DATE_FORMAT} hh:mm:ss`]),
  horario_fin: toMoment(`${c.fecha_cita} ${c.horario_fin}`, [`${DATE_FORMAT} hh:mm:ss`]),
});

/**
 * GET Citas
 * param {object} params
 * @returns {Promise<object>}
 */
export const getCitasPublic = async (params) => {
  try {
    const response = await API.get('recaudacion/citas-public/', { params });
    return response.data.map(formatter);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Citas
 * param {object} params
 * param {boolean} allPages
 * @returns {Promise<object>}
 */
export const getCitas = async (params, allPages) => {
  try {
    const response = await API.get(baseURI, { params });
    if (allPages) {
      if (!response.data.next) return response.data.results.map(formatter);
      const page = new URL(response.data.next).searchParams.get('page');
      const _citas = await getCitas({ ...params, page }, allPages);
      response.data.results = response.data.results.map(formatter);
      return response.data.results.concat(_citas);
    }
    if (response.data.results) {
      response.data.results = response.data.results.map(formatter);
      return response.data;
    }
    return response.data.map(formatter);
  } catch (err) {
    onError(err);
    return params.page || allPages ? { results: [] } : [];
  }
};

/**
 * POST Cita
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCita = async (_values) => {
  try {
    const values = getFormattedValues(_values);
    const response = await API.post(baseURI, values);
    message.info(response.detail || 'Agregado correctamente');
    return formatter(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Cita
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchCita = async (id, _values) => {
  try {
    const values = getFormattedValues(_values, { clean: false });
    const response = await API.patch(`${baseURI}${id}`, values);
    if (_values.estado_de_cita) {
      await postHistorialDeCita({
        cita: id,
        observaciones: _values.observaciones,
        estado_de_cita: _values.estado_de_cita,
      });
    }
    message.info(response.detail || 'Editado correctamente');
    return formatter(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Cita
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteCita = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    message.info(response.detail || 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
